define('lq/events/actions/focus',[
    'lq/events/actions/eventAction',
    'jquery'
], function (EventAction, $) {
    'use strict';

    function Focus(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(Focus, EventAction);

    Focus.typeName = 'Focus';

    Focus.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    Focus.prototype.execute = function (continuation, eventActionResponse) {
        var drop = this.piping.dropFactory.findDropById(this.eventData.morphId);
        if (drop)
            drop.focus();

        continuation();
    };

    return Focus;
});
